var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.showContent)?[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$t('model.auth.activation_failed'))}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }